import {FC} from 'react';
import {Select} from 'antd';
import {AppsFilter, getEnumOptions} from 'src/utils/enums';
import Arrow from '@svg/chevron-down_20.svg?react';
import './AppsFilterSelect.scss';

interface AppsFilterSelectProps {
    value: AppsFilter;
    onChange: (value: AppsFilter) => void;
}

const AppsFilterSelect: FC<AppsFilterSelectProps> = ({value, onChange}) => (
    <Select
        value={value}
        onChange={onChange}
        className="select-apps-filter"
        suffixIcon={<Arrow />}
        options={getEnumOptions(AppsFilter)}
        style={{ width: 100 }}
    />
);

export default AppsFilterSelect;
